import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {FormattedMessage} from 'react-intl';

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  header: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    marginBottom: 20
  },
  line: {
    backgroundColor: '#acacac',
    height: 1,
    width: '100%'
  },
  templateCard: {
    marginBottom: theme.spacing(2),
    cursor: 'pointer',
    transition: 'all 0.2s',
    '&:hover': {
      boxShadow: theme.shadows[4]
    }
  },
  templateButton: {
    marginTop: theme.spacing(1)
  },
  noTemplates: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic'
  }
}));

// the section shown within the ticket to include the store order buttons
const StoreOrderSection = ({templates, ticketId}) => {
  const classes = useStyles();

  if (!templates || templates.length === 0) {
    return null;
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <h2>
          <FormattedMessage id="store_order_forms.section_title" />
        </h2>
        <div className={classes.line} />
      </div>
      {templates.map(template => (
        <Card key={template.id} className={classes.templateCard}>
          <CardContent>
            <Button
              component={Link}
              to={`/store-order/${template.id}/${ticketId}`}
              variant="contained"
              color="primary"
              className={classes.templateButton}>
              <FormattedMessage
                id="store_order_forms.create_button"
                values={{template: template.name}}
              />
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

StoreOrderSection.propTypes = {
  templates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  ticketId: PropTypes.string.isRequired
};

export default StoreOrderSection;
